import type {
  VatImportMode,
  VatImportPreview,
  VatImportReceipt,
  VatImportResult,
} from '@tosho/contracts';

export async function bundleVatPdfs(files: readonly File[]): Promise<Uint8Array> {
  const { default: JSZip } = await import('jszip');
  const zip = new JSZip();
  for (let i = 0; i < files.length; i += 1)
    zip.file(`piece-${String(i + 1).padStart(3, '0')}.pdf`, await files[i]!.arrayBuffer());
  return zip.generateAsync({ type: 'uint8array', compression: 'STORE' });
}
async function upload<T>(
  bytes: Uint8Array,
  mode: VatImportMode,
  csrfToken: string,
  digest?: string,
): Promise<T> {
  const response = await fetch(
    `/api/finance/vat-declarations/${mode === 'historical' ? 'historical' : 'current-year'}/${digest ? 'confirm' : 'preview'}`,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/zip',
        'X-CSRF-Token': csrfToken,
        ...(digest ? { 'X-Tosho-Archive-Sha256': digest } : {}),
      },
      body: new Blob([Uint8Array.from(bytes)]),
    },
  );
  if (!response.ok) throw new Error('Le dépôt des CA3 ne peut pas être traité.');
  return response.json() as Promise<T>;
}
export const vatDeclarationsApi = {
  preview: (bytes: Uint8Array, mode: VatImportMode, csrfToken: string): Promise<VatImportPreview> =>
    upload(bytes, mode, csrfToken),
  confirm: (
    bytes: Uint8Array,
    mode: VatImportMode,
    csrfToken: string,
    digest: string,
  ): Promise<VatImportResult> => upload(bytes, mode, csrfToken, digest),
  async history(): Promise<readonly VatImportReceipt[]> {
    const response = await fetch('/api/finance/vat-declarations/history', {
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('Historique TVA indisponible.');
    return response.json() as Promise<readonly VatImportReceipt[]>;
  },
};
